export const GET_HEAD_ORGSS = "GET_HEAD_ORGSS"
export const ADD_HEAD_ORGS = "ADD_HEAD_ORGS"
export const UPDATE_HEAD_ORGS = "UPDATE_HEAD_ORGS"
export const GET_HEAD_ORGS_BY_ID = "GET_HEAD_ORGS_BY_ID"

/**
 * action creator function to get organizations
 * @param orgs: orgs from api response data
 * @returns {{orgs, type: string}}
 */

export const getHeadOrgs = (headOrgs) => {
  return {
    type: GET_HEAD_ORGSS,
    headOrgs: headOrgs,
    headOrg: null,
  }
}

/**
 * action creator function to add organization
 * @param org: org from api response data
 * @returns {{org, type: string}}
 */
export const addHeadOrg = (headOrg) => {
  return {
    type: ADD_HEAD_ORGS,
    headOrg: headOrg,
  }
}

/**
 * action creator function to get organization by id
 * @param headOrg:headOrg from api response data
 * @returns {{org, type: string}}
 */
export const getHeadOrgById = (headOrg) => {
  return {
    type: GET_HEAD_ORGS_BY_ID,
    headOrg: headOrg,
  }
}

/**
 * action creator function to update organization
 * @param headOrg:headOrg from api response data
 * @returns {{org, type: string}}
 */
export const updateHeadOrg = (headOrg) => {
  return {
    type: UPDATE_HEAD_ORGS,
    headOrg: headOrg,
  }
}
